<template>
  <div v-if="!isReadOnlyUser">
    <div class="row mb-4">
      <div class="col-md-12 mb-20">
        <router-link
          :to="{ path: '/shirt/scan/fabric/shirt_order' }"
          class="btn btn btn-info"
        >
          Shirt Order
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/product_order' }"
          class="btn btn btn-info"
        >
          Product Order
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/soft_and_neat' }"
          class="btn btn btn-info"
        >
          S & N
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/oem' }"
          class="btn btn btn-info"
        >
          OEM
        </router-link>
      </div>
      <div class="col-md-12 mb-20">
        <router-link
          :to="{ path: '/shirt/scan/fabric/repair' }"
          class="btn btn btn-info"
        >
          Repair
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/book' }"
          class="btn btn btn-info"
        >
          Book
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/sample' }"
          class="btn btn btn-info"
        >
          Sample
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/c_and_c_cutting' }"
          class="btn btn btn-info"
        >
          C & C Cutting
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/fabric_cutter' }"
          class="btn btn btn-info"
        >
          Fabric Cutter
        </router-link>
      </div>
      <div class="col-md-12">
        <router-link
          :to="{ path: '/shirt/scan/fabric/damage' }"
          class="btn btn btn-info"
        >
          Damage
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/return' }"
          class="btn btn btn-info"
        >
          Return
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/sale' }"
          class="btn btn btn-info"
        >
          Sale
        </router-link>
        <router-link
          :to="{ path: '/shirt/scan/fabric/stock_correction' }"
          class="btn btn btn-info"
        >
          Stock Correction
        </router-link>
      </div>
    </div>
    <hr />
    <router-view></router-view>
  </div>
  <div class="grid bg-white" v-else>
    <div class="grid-body">
      <h4>
        You don't have the privilege to do this action, please contact an
        administrator.
      </h4>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isReadOnlyUser: false,
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
  },
};
</script>
<style scoped>
.btn.active {
  background: var(--primary-color) !important ;
}
</style>
